<template>
  <!--
    	作者：kmdshop
    	时间：2020-04-26
    	描述：门店-编辑门店
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="80px">
      <!--编辑门店-->
      <div class="common-form">编辑门店</div>
      <el-form-item label="门店名称" prop="store_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.store_name" placeholder="请输入门店名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="门店logo">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="file_path!=''" class="img">
            <img :src="file_path" width="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="店长" prop="linkman" :rules="[{required: true,message: ' '}]">
        <div class="d-s-s d-c">
          <el-button @click="openGetUser" icon="el-icon-plus">选择店长</el-button>
          <ul class="d-s-s select-user">
            <li class="mr10 d-c-c d-c p-10-0" v-for="(item,index) in select_list" :key="index">
              <img :src="item.user.avatarUrl" class="radius" width="30" height="30" />
              <p class="lh18 ww100 text-ellipsis">{{item.user.nickName}}</p>
            </li>
          </ul>
        </div>
      </el-form-item>
      <!-- <el-form-item label="商家" prop="linkman" :rules="[{required: true,message: ' '}]">
        <div class="d-s-s d-c">
          <el-button @click="openGetSupply" icon="el-icon-plus">关联商家</el-button>
          <ul class="d-s-s select-user">
            <li class="mr10 d-c-c d-c p-10-0" >
              <img v-if="form.supplys" :src="form.supplys.image_url" class="radius" width="30" height="30" />
              <p v-if="form.supplys" class="lh18 ww100 text-ellipsis">{{form.supplys.name}}</p>
            </li>
          </ul>
        </div>
      </el-form-item> -->
      <!-- <el-form-item label="佣金比例" prop="commission_rate" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.commission_rate" placeholder="请输门店抽成比例,收益会到店长账户" class="max-w460" :max="100" :min="0">
          <template slot="append">%</template>
        </el-input>
      </el-form-item> -->
      <el-form-item label="联系人" prop="linkman" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.linkman" placeholder="请输入门店联系人" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.phone" placeholder="请输入门店联系电话" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="营业时间" prop="shop_hours" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.shop_hours" placeholder="请输入营业时间,例如:8:30-17:30" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="店铺二维码">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('qrcode')">选择图片</el-button>
          <div v-if="form.store_qrcode!=''" class="img">
            <img :src="form.store_qrcode" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="小程序appid" prop="store_wxappid" >
        <el-input v-model="form.store_wxappid" placeholder="请输入小程序appid" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="小程序页面路径" prop="store_wxapp_url" >
        <el-input v-model="form.store_wxapp_url" placeholder="请输入小程序页面路径" class="max-w460"></el-input>
        <div class="help">不填写则直接进入首页</div>
      </el-form-item>

      <el-form-item label="门店区域">
        <el-select v-model="form.province_id" placeholder="省" @change="initCity">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
        </el-select>
        <el-select v-if="form.province_id!=''" v-model="form.city_id" placeholder="市" @change="initRegion">
          <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[form.province_id]['city']"
            :key='index1'></el-option>
        </el-select>
        <el-select v-if="form.city_id!=''" v-model="form.region_id" placeholder="区">
          <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[form.province_id]['city'][form.city_id]['region']"
            :key='index2'></el-option>
        </el-select>

      </el-form-item>
      <el-form-item label="详细地址" prop="address" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.address" placeholder="请输入详细地址" class="max-w460"></el-input>
      </el-form-item>
        <el-form-item label="门牌号" prop="house_number" >
          <el-input v-model="form.house_number" placeholder="请输入门牌号" class="max-w460"></el-input>
        </el-form-item>
      <el-form-item label="门店坐标">
        <el-row class="mb16">
          <el-col :span="24">
            <el-input v-model="form.coordinate" class="max-w460"></el-input>
          </el-col>
        </el-row>
        <el-row class="mb16">
          <el-col :span="24">
            <GetPoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></GetPoint>
          </el-col>
        </el-row>

      </el-form-item>
      <el-form-item label="门店简介">
        <el-input type="textarea" v-model="form.summary" placeholder="请输入门店简介" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="门店排序">
        <el-input type="number" v-model="form.sort" placeholder="请输入门店排序" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="自提核销">
        <el-radio-group v-model="form.is_check">
          <el-radio :label="1">支持</el-radio>
          <el-radio :label="0">不支持</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="门店状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否通过">
        <el-radio-group v-model="form.audit_status">
          <el-radio :label="1">通过</el-radio>
          <el-radio :label="2">不通过</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="不通过理由" prop="reject_reason" v-if="form.audit_status == 2">
        <el-input v-model="form.reject_reason" placeholder="请输入不通过理由" class="max-w460"></el-input>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>

    <!--选择用户-->
    <StoreUser :storeId="Number(form.store_id)" :is_open="isOpenGetUser" :multi="false" @close="closeGetUserFunc"></StoreUser>

     <!--选择商家-->
     <SupplyX :isproduct="isOpenGetSupply" :multi="false" @closeDialog="closeGetSupplyFunc"></SupplyX>
  </div>
</template>

<script>
  import GetPoint from '@/components/map/Getpoint.vue';
  import StoreApi from '@/api/store.js';
  // import select_region from '@/utils/select.region.js';
  import select_region from '@/utils/select.district.js';
  import Upload from '@/components/file/Upload';
  import { formatModel } from '@/utils/base.js'
  import StoreUser from '@/components/user/StoreUser'
  import SupplyX from '@/components/supply/Supply'
  export default {
    components: {
      /*腾讯地图拾取器*/
      GetPoint,
      Upload,
      StoreUser,
      SupplyX
    },
    data() {
      return {
        /*form表单数据*/
        form: {
          store_id:null,
          store_name: '',
          linkman: '',
          phone: '',
          shop_hours: '',
          province_id: '',
          city_id: '',
          region_id: '',
          address: '',
          house_number:"",
          coordinate: '',
          summary: '',
          sort: '',
          is_check: '',
          status: '',
          store_qrcode: '',
          store_wxapp_url: '',
          store_wxappid: '',
          logo_image_id: 0,
          commission_rate: 0,
          supplys:{
            supply_id:0
          },
          audit_status:1,//1   通过  2  驳回
          reject_reason:"",//不通过理由
        },
        /*省市区*/
        areaList: select_region,
        /*查询信息*/
        list: [],
        /*是否上传图片*/
        isupload: false,
        loading: false,
        file_path: '',
        // 选择用户开关
        isOpenGetUser: false,
        select_list: [],
        //选择商家开关
        isOpenGetSupply:false,
        select_list_supply:[],

        file_type:'',
      };
    },
    created() {
      this.form.store_id =this.$route.query.store_id
      this.getData();
    },

    methods: {
      /*修改*/
      onSubmit() {
        let self = this;
        let form = self.form;
        if (self.select_list && self.select_list.length > 0) {
          form.clerk_id = self.select_list[0].clerk_id
        }
        if(self.form.supplys  && self.form.supplys.supply_id){
          form.supply_id = self.form.supplys.supply_id
        }else{
          form.supply_id =0
        }
       

        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            StoreApi.editShop(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，门店修改成功',
                  type: 'success'
                });
                self.$router.push('/store/store/index');
              }).catch(error => {
                self.loading = false;
              });
          }
        });
      },
      /*初始化城市id*/
      initCity() {
        this.form.city_id = ''
      },
      /*初始化区id*/
      initRegion() {
        this.form.region_id = ''
      },

      /*获取经纬度*/
      getMapdataFunc(e) {
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },

      /*获取参数*/
      getData() {
        let self = this;
        StoreApi.shopDetail({
            store_id: self.form.store_id
          }, true)
          .then(res => {
            self.select_list = res.data.model.shopManager ? [res.data.model.shopManager] : []
            self.form = formatModel(self.form, res.data.model);
            self.form.supplys = res.data.model.supplys;

            self.form.is_check = res.data.model.is_check.value;
            self.form.status = res.data.model.status.value;
            if(res.data.model.logo){
              self.file_path = res.data.model.logo.file_path;
            }
          })
          .catch(error => {

          });

      },

      /*上传*/
      openUpload(e) {
        this.file_type = e;
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          if(this.file_type=='qrcode'){
            this.form.store_qrcode = e[0].file_path;
          }else{
            this.file_path = e[0].file_path;
            this.form.logo_image_id = e[0].file_id;
          }

        }
        this.isupload = false;
      },

      /*选择的地址*/
      choseFunc(e){
        this.form.coordinate=e.location.lat+','+e.location.lng;
        this.form.address=e.address;
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      /*打开获取用户*/
      openGetUser() {
        this.isOpenGetUser = true
      },
      /*关闭获取用户*/
      closeGetUserFunc(e) {
        if (e.type != 'error') {
          this.select_list = [e.params]
        }
        this.isOpenGetUser = false
      },
      // 打开获取商家
      openGetSupply(){
        this.isOpenGetSupply = true;
      },
      /*关闭获取用户*/
      closeGetSupplyFunc(e) {
        console.log(e)
        if (e.type != 'error') {
          this.form.supplys = e.params[0]
        }
        this.isOpenGetSupply = false
      },

    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/store/store/edit.vue